import {
	createHook,
	type BoundActions,
	type HookFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import type { State } from './State';
import { store } from './store';

export const useAgentDebugModal: HookFunction<
	State,
	BoundActions<
		State,
		{
			openModal: ({
				messageId,
				conversationId,
			}: {
				messageId: string;
				conversationId: string;
			}) => ({ setState }: StoreActionApi<State>) => Promise<void>;
			closeModal: () => ({ setState }: StoreActionApi<State>) => void;
		}
	>,
	void
> = createHook(store);
